import EmptyIcon from "../../../assets/icons/EmptyIcon";
import React from "react";
import "./EmptyScreen.css";

type EmptyScreenProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  fullHeight?: boolean;
};

function EmptyScreen({
  title,
  subtitle,
  action,
  className = "",
  fullHeight = false,
}: EmptyScreenProps) {
  const resolvedClassName = [
    "empty-screen",
    fullHeight ? "empty-screen--full-height" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={resolvedClassName} role="status" aria-live="polite">
      <EmptyIcon />
      <p className="empty-screen__title">{title}</p>
      {subtitle ? <p className="empty-screen__subtitle">{subtitle}</p> : null}
      {action ? <div className="empty-screen__action">{action}</div> : null}
    </div>
  );
}

export default EmptyScreen;
